module.exports = __webpack_public_path__ + "fonts/Lufthansa Text Bold.5569ccdd.eot";